module.exports = __webpack_public_path__ + "static/media/news-02.b491932e.jpg";